import http from '~/common/http'
import CommonService from '~/services/common'
import OrderService from "~/services/order";
import Config from "~/config/params";

const Model = {
    id: 0,
    name: "",
    stages: [],
    type: "",
    level: "",
    maturity: "",
    memo: "",
    province_id: 0,
    city_id: 0,
    district_id: 0,
    class_num: 0,
    user_id: 0,
    teacher_num: 0,
    prefix: '',
    customer_ids: [],
};


//客户类型
// const Types = [
//     {'0': '全部'},
//     {'1': '普通学校'},
//     {'2': '培训机构'},
//     {'3': '教育局'},
//     {'4': '个人'},
//     {'6': '公司'},
//     {'5': '其他'},
// ];

//客户类型
const Types = {
    0:'不限',
    1: '普通学校',
    2: '培训机构',
    3: '教育局',
    4: '个人',
    5: '其他',
    6: '公司',
    7: '测试学校',
};

// 客户来源
const Source = {
    0: '不限',
    1: '系统客户',
    2: '开发',
    3: '运营',
    4: '网上搜索',
    5: '客户介绍',
    6: '市场',
    7: '项目招标',
    8: '区域自拓'
};

//客户等级
const Levels = {
    0:'不限',
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'E',
};

//客户成熟度
const Maturity = {
    0: '无',
    1: '非重点跟进客户',
    2: '重点跟进客户',
};

export default {

    // 得到客户模型实例
    getModel() {
        return Model;
    },

    //得到客户类型枚举
    getTypes(is_search = false) {
        let types = Types;
        if(!is_search){
            delete types[0];
        }
        return types;
    },

    //得到客户来源枚举类型
    getSource(is_search = false) {
        let source = Source;
        if(!is_search){
            delete source[0];
        }
        return source;
    },

    //得到客户等级枚举
    getLevels(is_search = false) {
        let levels = Levels;
        if(!is_search){
            delete levels[0];
        }
        return levels;
    },

    //得到客户成熟度枚举
    getMaturity() {
        return Maturity;
    },

    //得到客户筛选项配置
    getFields(path, active_name) {
        return [
            {field: 'base', label: '基础信息筛选条件', children: [
                {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                {field: 'id', label: '客户ID', type: 'input'},
                {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict', clearable: true},
                {field: 'product_type', label: '订单类型', type: 'select', list: OrderService.getOrderType()},
                active_name == 'public' ? {field: 'tag', label: '客户标签', type: 'select', list: [{value: '', label: '不限'}, {value: 'failed', label: '未成交客户'}, {value: 'excess', label: '超库容解绑'}, {value: 'overtime', label: '超时未成交客户'}]} : null,
                {field: 'product_id', label: '产品筛选', type: 'components', ref: 'product', components: 'Product', change: 'getValue'},
                path == '/customers/index' ? {field: 'branch_id', label: '所属部门', type: 'components', ref: 'branch', components: 'UserCascader', change: 'changeCascaderLast'} : null,
                active_name != 'my-index' ? {field: 'username', label: '业务员姓名', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'} : null,
                {field: 'level', label: '客户级别', type: 'select', list: Object.keys(Levels).map(key => ({ value: key, label: Levels[key] }))},
                path != '/customers/public' ? {field: 'repay_type', label: '回款情况', type: 'select', list: [{value: 0, label: '不限'}, {value: 1, label: '未回款'}, {value: 2, label: '部分回款'},{value: 3, label: '全部回款'}]} : null,
                {field: 'stop_renew', label: '是否断续', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}]},
                {field: 'type', label: '客户类型', type: 'select', list: Object.keys(Types).map(key => ({ value: key, label: Types[key] }))},
                path == '/customers/my-index' ? {field: 'traceTimes', label: '跟进时间', type: 'daterange'} : {field: 'tag_ids', label: '名校标签', type: 'components', ref: 'tag', components: 'TagSelect', change: 'changeProduct'},
                path == '/customers/my-index' ? {field: 'is_cooperator', label: '是否有协作人', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]} : {field: 'school_type', label: '办学性质', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '民办'}, {value: 2, label: '公办'}]},
                path == '/customers/my-index' ? {field: 'is_overtime', label: '是否为超时未成交客户', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]} : null,
                path != '/customers/my-index' ? {field: 'is_cooperator', label: '是否有协作人', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]} : null,
                {field: 'maturity', label: '成熟度', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '非重点跟进客户'}, {value: 2, label: '重点跟进客户'}]},
            ]},
            {field: 'date', label: '时间筛选条件', children: [
                path == '/customers/my-index' ? {field: 'tag_ids', label: '名校标签', type: 'components', ref: 'tag', components: 'TagSelect', change: 'changeProduct'} : {field: 'traceTimes', label: '跟进时间', type: 'daterange'},
                path == '/customers/my-index' ? {field: 'school_type', label: '办学性质', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '民办'}, {value: 2, label: '公办'}]} : null,
                {field: 'product_times', label: '产品到期时间', type: 'daterange'},
                {field: 'nextTimes', label: '下次跟进时间', type: 'daterange'},
                {field: 'time_type', data_field: 'create_times', label: '创建时间', type: 'select-date', list: [{value: 1, label: '客户创建时间'}, {value: 2, label: '录单时间'},{value: 3, label: '客户绑定时间'}]},
                active_name == 'excess' ? {field: 'nextTimes', label: '解绑时间', type: 'daterange'} : null,
            ]},
            {field: 'other', label: '其他筛选条件', children: [
                {field: 'time_status', label: '是否到期', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '已到期'}, {value: 2, label: '未到期'}]},
                {field: 'down_num', label: '下载不少于', type: 'input'},
                {field: 'subject_num', label: '科目不少于', type: 'input'},
                {field: 'stages', label: '开设学段', type: 'select', list: [{value: 'is_grade_school', label: '小学'}, {value: 'is_middle_school', label: '初中'}, {value: 'is_high_school', label: '高中'}, {value: 'is_vsh_school', label: '职中'}], multiple: true, clearable: true},
                {field: 'origin', label: '客户来源', type: 'select', list: Object.keys(Source).map(key => ({ value: key, label: Source[key] }))},
                path != '/customers/public' ? {field: 'is_bind', label: '是否绑定', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '已绑定'}, {value: 0, label: '未绑定'}]} : null,
                {field: 'child', label: '是否合并', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]},
                {field: 'customer_ids', label: '名称精准搜索', type: 'components', ref: 'customerIds', components: 'CustomerSelectMultiple', change: 'getValue'},
                path == '/customers/public' ? {field: 'key_word', label: '跟进记录关键字', type: 'input'} : null,
                {field: 'cooperator_id', label: '客户协作人', type: 'components', ref: 'cooperator', components: 'UserSelect', change: 'changeObjLabel'},
                {field: 'is_mobile', label: '是否有联系人', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '有联系人仅申请'}, {value: 0, label: '否'}]},
                path != '/customers/index' ? {field: 'formal_status', label: '成交状态', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '新增成交'}, {value: 2, label: '二次成交'}]} : null,
            ]},
        ];
    },

    // 创建客户
    create(customer) {
        return http.post('/api/customers/create', customer)
    },

    //更新客户信息
    update(customer) {
        return http.put('/api/customers/update?id=' + customer.id, customer);
    },

    //更新我的客户信息
    updateMy(customer) {
        return http.put('/api/customers/my-update?id=' + customer.id, customer);
    },

    getDone(params){
        return http.get('/api/customers/done', {
            params: params
        });
    },

    getTranceLog(params) {
        return http.get('/api/customers/trance-log', {
            params: params
        });
    },

    //全部客户 已经与业务员产生关联的客户列表 user_customers INNER JOIN customers
    getList(params) {
        return http.get('/api/customers/index', {
            params: params
        });
    },

    //我的客户
    getMyList(params) {
        return http.get('/api/customers/my-index', {
            params: params
        });
    },

    //客户公海池
	getPublicList(params) {
        return http.get('/api/customers/public', {
            params: params
        });
    },

    //我的占用库容客户
    getMyUnsold(params) {
        return http.get('/api/customers/my-unsold', {
            params: params
        });
    },

    productSwitch(params){
        return http.post('/api/customers/product-switch', params)
    },

    /**
     * 获取产品配置
     * @param params
     * @returns {AxiosPromise<any>}
     */
    product_config(params){
        return http.get('api/product/default/product-config',{
            params: params
        })
    },
    /**
     * 获取校网通用户组配置
     * @returns {AxiosPromise<any>}
     */
    box_config(params){
        return http.get('api/product/default/get-box-config',{
            params: params
        })
    },

    //得到单个客户信息
    getInfo(customerId) {
        return http.get('/api/customers/view', {
            params: {
                id: customerId
            }
        })
    },

    /**
     * 得到客户所开通的产品信息
     * @param customerId
     * @returns {AxiosPromise<any>}
     */
    getProducts(customerId){
        return http.get('/api/customers/products', {
            params: {
                id: customerId
            }
        })
    },

    /**
     * 通过客户ID获取联系人列表
     * @param {*} customerId
     */
    getContacts(customerId) {
        return CommonService.getContacts({
            customer_id: customerId
        });
    },


	/**
     * 绑定客户
	 * @param customer_Ids
	 * @returns {IDBRequest | Promise<void>}
	 */
	bind(params) {
        return http.put('/api/customers/bind',params);
    },

	/**
	 * 绑定客户
	 * @param customer_ids
	 * @returns {IDBRequest | Promise<void>}
	 */
	unbind(params) {
		return http.put('/api/customers/unbind',params);
    },

    /**
     * 接管客户
	 */
	takeOver(params) {
        return http.put('/api/customers/take-over', params);
    },

    // 删除客户
    delete(params) {
        return http.delete('/api/customers/delete', {
            data: params
        })
    },

    /**
     * 获取客户变更日志
     * @param customer_id
     * @returns {*}
     */
    getChangeLogs(params) {
        // console.log(params);
	    return http.get('/api/customer/change-logs/index', {
            params: params
        })
    },

    /**
     * 获取客户绑定日志
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getBindLog(params) {
         return http.get('/api/customer/bind-logs/index',{
             params: params
         })
    },

    /**
     * 获取回访客户列表
     * @param params
     * @returns {*}
     */
    getVisitCustomers(params) {
        return http.get('/api/customers/visits', {
            params: params
        });
    },

    /**
     * 获取我的回访客户
     * @param params
     * @returns {*}
     */
    getMyVisitCustomers(params) {
        return http.get('/api/customers/my-visits', {
            params: params
        });
    },

    /**
     * 分配客服
     * @param params
     * @returns {*}
     */
    assign(params) {
        return http.post('/api/customers/assign', params);
    },

    /**
     * 解除客服分配关系
     * @param params
     * @returns {*}
     */
    removeAssign(params) {
        return http.post('/api/customers/remove-assign', params)
    },

    /**
     * 设置账号前缀
     * @param customer
     * @returns {*}
     */
    setPrefix(customer) {
        return http.put('/api/customers/set-prefix?id=' + customer.id, customer);
    },

    checkPrefix(params) {
        return http.post('/api/customers/check-prefix?id=' + params.customer_id, params);
    },

    /**
     * 得到客户下上一次填写的发票信息
     * @param customerId
     * @returns {AxiosPromise<any>}
     */
    getLastInvoice(customerId) {
        return http.get('/api/customers/last-invoice', {
            params: {
                id: customerId
            }
        })
    },

    /**
     * 得到客户上一次填写的快递信息
     * @param customerId
     * @returns {AxiosPromise<any>}
     */
    getLastExpress(customerId) {
        return http.get('/api/customers/last-express',  {
            params: {
                id: customerId
            }
        });
    },

    getLastAddress(customerId) {
        return http.get('/api/customers/last-address',  {
            params: {
                id: customerId
            }
        });
    },

    /**
     * 合并客户
	 * @param customer_Ids
	 * @returns {IDBRequest | Promise<void>}
	 */
	merge(params) {
        return http.put('/api/customers/merge',params);
    },

    /**
     * 修改地区
	 * @param customer_Ids
	 * @returns {IDBRequest | Promise<void>}
	 */
	changeArea(params) {
        return http.put('/api/customers/change-area',params);
    },


    /**
     * 修改地区
	 * @param customer_Ids
	 * @returns {IDBRequest | Promise<void>}
	 */
	export(params) {
        return http.get('/api/customers/export',params);
    },

    //得到合并子客户
    getChild(params) {
        return http.get('/api/customers/get-child', {
            params: params
        })
    },

    //取消合并
    cancelMerge(customerId) {
        return http.put('/api/customers/cancel-merge', {id: customerId});
    },

    /**
     * 获取菜单配置
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getMenu(params){
        return http.get('api/product/default/get-menu',{
            params: params
        })
    },

    createMenu(params){
        return http.put('/api/product/default/create-menu?customer_id=' + params.customer_id + '&product_code=' + params.product_code + '&menu_id=' + params.menu_id, params)
    },

    deleteMenu(params){
        return http.delete('/api/product/default/delete-menu?customer_id=' + params.customer_id + '&product_code=' + params.product_code + '&menu_id=' + params.menu_id, params)
    },

    /**
     * 获取客户绑定日志
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getTransitLog(params) {
        return http.get('/api/customer/transit-logs/index',{
            params: params
        })
    },

    /**
     * 删除客户列表
     * @param params
     */
    getRecycleList(params) {
        return http.get('/api/customers/recycle-list',{
            params: params
        })
    },

    // 恢复客户
    revert(params) {
        return http.put('/api/customers/revert', params);
    },

    //退款产品
    getRefundProduct(params) {
        return http.get('/api/customers/refund-product', {
            params: params
        });
    },

    //客户资源统计
    getDownloadCount(params) {
        return http.get('/api/customers/download-count', {
            params: params
        });
    },

    //导出客户资源统计
    exportDownloadCount(params) {
        return http.get('/api/customers/export-download-count', {
            params: params
        });
    },

    //客户合作查询
    getQueryInfo(params) {
        return http.get('/api/customers/query-info', {
            params: params
        });
    },
    // 高价值客户推荐
    getHighValueList(params) {
        return http.get('/api/high-value-customers/index', {
            params: params
        });
    },
    // 智能客户洞察
    getHighValueView(id) {
        return http.get('/api/high-value-customers/view', {
            params: {id: id}
        });
    },
    getHighValuePreview(id) {
        return http.get('/api/high-value-customers/preview', {
            params: {id: id}
        });
    },
    refreshHighValueInsight(id) {
        return http.post('/api/high-value-customers/refresh', {id: id});
    },
    claimHighValueCustomer(id) {
        return http.post('/api/high-value-customers/claim', {id: id});
    },
    unbindHighValueCustomer(customerIds) {
        return http.post('/api/high-value-customers/unbind', {customer_ids: customerIds});
    },
    getHighValueBound() {
        return http.get('/api/high-value-customers/bound');
    },
    getHighValueContactMobile(id, contactId) {
        return http.get('/api/high-value-customers/contact-mobile', {
            params: {id: id, contact_id: contactId}
        });
    },
    highValueAssistant(id) {
        return http.post('/api/high-value-customers/assistant', {id: id});
    },
    getHighValueAssistantHistory(id, sessionId) {
        return http.get('/api/high-value-customers/assistant-history', {
            params: {id: id, session_id: sessionId || undefined}
        });
    },
    chatHighValueAssistant(payload) {
        return http.post('/api/high-value-customers/assistant-chat', payload, {timeout: 180000});
    },
    newHighValueAssistantSession(id) {
        return http.post('/api/high-value-customers/assistant-new', {id: id});
    },
}



// WEBPACK FOOTER //
// ./src/services/customer.js